var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorRingLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "ldio-hvsvewj5yuf-mask"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 20,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeDasharray: "94.24777960769379 31.41592653589793",
    strokeWidth: 9
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 50 50;360 50 50",
    times: "0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ldio-hvsvewj5yuf-mask)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 0,
    width: 20.333333333333332,
    height: 100,
    fill: "#3a44b0"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#3a44b0;#c8cbeb;#3a44b0",
    times: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.6666666666666666s"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39.83333333333333,
    y: 0,
    width: 20.333333333333332,
    height: 100,
    fill: "#c8cbeb"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#3a44b0;#c8cbeb;#3a44b0",
    times: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.3333333333333333s"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 59.166666666666664,
    y: 0,
    width: 20.333333333333332,
    height: 100,
    fill: "#3a44b0"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#3a44b0;#c8cbeb;#3a44b0",
    times: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0s"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorRingLoading);
export default __webpack_public_path__ + "static/media/color-ring-loading.bca4664541a3f5ba3b274d4ad8ff6f7a.svg";
export { ForwardRef as ReactComponent };